import { get } from "lodash-es";
import { MESApiService, getMomentTz, spParameter } from "../../../../services";
import { Entry } from "../../entry/models/Entry";

const moment = getMomentTz();

export const getEntriesReport = async (
	params: {
		startShiftId?: number | null;
		endShiftId?: number | null;
		assetId?: number | null;
		sectionIds?: number[];
	},
	signal?: AbortSignal,
) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "StartShiftId", value: params.startShiftId as number },
		{ name: "EndShiftId", value: params.endShiftId as number },
	];

	if (params.assetId) {
		parameters.push({ name: "AssetId", value: params.assetId });
	}

	// Pass comma-separated sectionIds for multi-select filter
	if (params.sectionIds && params.sectionIds.length > 0) {
		parameters.push({ name: "SectionIds", value: params.sectionIds.join(",") });
	}

	// Use SWV.GetSectionLogbookEntries which extends LB.GetEntries with section info
	const resp = await apiService.callV2(
		"[SWV].[GetSectionLogbookEntries]",
		parameters,
		signal,
	);

	if (resp.ok) {
		let rows = get(resp, "data.tables[0].rows", []) as Entry[];

		rows = rows.map((entry: Entry) => ({
			...entry,
			CreateTimestamp: entry.CreateTimestamp
				? moment.utc(entry["CreateTimestamp"]).toDate()
				: null,
			UpdateTimestamp: entry.UpdateTimestamp
				? moment.utc(entry["UpdateTimestamp"]).toDate()
				: null,
		}));

		return rows;
	} else {
		throw new Error(resp.message || "Error fetching entries");
	}
};
